import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkRowLock } from '@redux/modules/rowLock';
import { isValidEntity } from '@utils/rowLock';
import usePrevious from '@hooks/usePrevious';

import {
  selectLoading,
} from '@redux/selectors/RowLockSelector';

const useRowChecked = entity => {
  const [checked, setChecked] = useState(false);
  const [checkInProgress, setCheckInProgress] = useState(false);
  const isLoading = useSelector(selectLoading);
  const previousEntity = usePrevious(entity);
  const dispatch = useDispatch();

  /* Check the entity lock status. */
  useEffect(() => {
    // When switching between components using rowlocking, there might still be a rowlocking operation taking place that relates to the
    // previous component. In this case, we want to delay the initial check for the new component until the running operation is complete.
    if (isLoading) return;

    const isNewEntity = entity !== previousEntity;
    if (isNewEntity) setChecked(false);
    if (!isValidEntity(entity)) return;

    if (isNewEntity || (!checked && !checkInProgress)) {
      setCheckInProgress(true);
      dispatch(checkRowLock(entity)).then(() => {
        setChecked(true);
        setCheckInProgress(false);
      });
    }
  }, [entity, isLoading]);

  return checked;
};

export default useRowChecked;
